module.exports = __webpack_public_path__ + "img/enterpirseph.e8502e3.png";